<template>
    <kiosk-user-details :userId="props.userId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <page-header>Details</page-header>

            <vx-expandable-card>
                <template v-slot:content>
                    <div class="flex flex-col gap-4">
                        <div class="flex flex-col gap-1">
                            <strong>Name:</strong>
                            <div class="text-sm text-slate-500">
                                {{ user.name || '-' }}
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>Email:</strong>
                            <div class="text-sm text-slate-500">
                                {{ user.email || '-' }}
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>Status:</strong>
                            <div class="text-sm text-slate-500" data-test="status">
                                <vx-popover hover arrow placement="top">
                                    {{ user.suspended_at ? 'Suspended' : 'Active' }}
                                    <template v-if="user.suspended_at" v-slot:content>
                                        <div class="max-w-xs">
                                            <div>Suspended on {{ shortDateTime(user.suspended_at) }}</div>
                                            <div v-if="user.suspension_reason">{{ user.suspension_reason }}</div>
                                        </div>
                                    </template>
                                </vx-popover>
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>Joined on:</strong>
                            <div class="text-sm text-slate-500">
                                {{ user.created_at ? shortDateTime(user.created_at) : '-' }}
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>Using SSO:</strong>
                            <div class="text-sm text-slate-500">
                                {{ true === user.isUsingSingleSignOn ? 'Yes' : 'No' }}
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>2FA Enabled:</strong>
                            <div class="text-sm text-slate-500">
                                {{ true === user.uses_two_factor_auth ? 'Yes' : 'No' }}
                            </div>
                        </div>
                        <div class="flex flex-col gap-1">
                            <strong>Time Zone:</strong>
                            <div class="text-sm text-slate-500">
                                {{ user.time_zone || '-' }}
                            </div>
                        </div>
                    </div>
                </template>
            </vx-expandable-card>
        </div>
    </kiosk-user-details>
</template>

<script setup>
import KioskUserDetails from './details/KioskUserDetails.vue';
import { VxExpandableCard, VxPopover } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { useUserDetails } from './composables/useUserDetails';
import { shortDateTime } from '~/utils/date';

const { user } = useUserDetails();

const props = defineProps({
    userId: {
        type: Number,
        required: true,
    },
});
</script>
